// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1quM4","additionalInfo":"AgreementModal_additionalInfo__Xji2g"};